// Document type → emoji icon mapping
const DOC_TYPE_ICON = {
  PASSPORT_COPY: '🛂',
  PASSPORT_PHOTO: '📸',
  EID_COPY: '🪪',
  VISA_COPY: '📋',
  TRADE_LICENSE: '🏢',
  ESTABLISHMENT_CARD: '🏭',
  OFFER_LETTER: '📄',
  MEDICAL_REPORT: '🏥',
  LABOUR_CONTRACT: '📝',
  NOC: '📜',
  SALARY_CERTIFICATE: '💰',
  BANK_LETTER: '🏦',
  POWER_OF_ATTORNEY: '⚖️',
  RESIGNATION_LETTER: '✉️',
  TENANCY_CONTRACT: '🏠',
  ENTRY_STAMP: '🛫',
};

export const getDocIcon = (code) => DOC_TYPE_ICON[(code || '').toUpperCase()] || '📄';
export default DOC_TYPE_ICON;
